module.exports = __webpack_public_path__ + "img/banner1.24d0d8f7.png";